import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classnames from 'classnames';
import React, {Component} from 'react';

import * as ObjectConst from '../../constants/Property';
import {updateField, setPricesValid} from '../../actions/CreatingObjectPage';
import {CURRENCY} from "../../constants/Property";

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    setPricesValid: isPricesValid => {
    },
    updateField: (objectId, updateFieldCommand) => {
    }
};

class Prices extends Component {
    constructor(props) {
        super(props);

        this.state = {
            PRICE_SELL: '',
            PRICE_RENT_LONG: '',
            PRICE_RENT_BASE: '',
            CURRENCY: '',
            TYPE_TERM: ObjectConst.TYPE_TERM.ALL
        }
    }

    componentWillReceiveProps(nextProps) {
        const {createdObject} = nextProps;
        if (createdObject.id !== undefined) {
            const price = createdObject.price;

            this.setState({
                TYPE_TERM: createdObject.props.typeTerm,
                CURRENCY: price.currency,
                PRICE_SELL: price.priceSell === 0 || price.priceSell === '0' ? '' : price.priceSell,
                PRICE_RENT_LONG: price.priceRentLong === 0 || price.priceRentLong === '0' ? '' : price.priceRentLong,
                PRICE_RENT_BASE: price.priceRentBase === 0 || price.priceRentBase === '0' ? '' : price.priceRentBase
            });
        }
    }

    updateField(event) {
        const updateFieldCommand = {
            name: event.target.name
        };

        switch (event.target.name) {
            case ObjectConst.FIELDS.PRICE_SELL:
            case ObjectConst.FIELDS.PRICE_RENT_LONG:
            case ObjectConst.FIELDS.PRICE_RENT_BASE:
                updateFieldCommand.value = event.target.value.length === 0 ? '0' : event.target.value;
                break;
            default:
                updateFieldCommand.value = event.target.value;
                break;
        }

        this.props.updateField(this.props.createdObject.id, updateFieldCommand);
        this.validation();
    }

    handleChange(event) {
        const newState = {};
        newState[event.target.name] = event.target.value;

        this.setState(newState);
    }

    validation = () => {
        const {type, isPricesValid, setPricesValid} = this.props;
        const {PRICE_RENT_BASE, TYPE_TERM, PRICE_RENT_LONG, PRICE_SELL} = this.state;
        let isPricesValidNew = true;

        if (type === ObjectConst.TYPE.RENT) {
            if (PRICE_RENT_BASE.length === 0) {
                isPricesValidNew = false;
            }
            if (TYPE_TERM === ObjectConst.TYPE_TERM.LONG) {
                if (PRICE_RENT_LONG.length === 0) {
                    isPricesValidNew = false;
                }
            }
        } else {
            if (PRICE_SELL.length === 0) {
                isPricesValidNew = false;
            }
        }

        if (isPricesValid !== isPricesValidNew) {
            setPricesValid(isPricesValidNew);
        }
    };

    render() {
        const {i18n, type} = this.props;
        const {PRICE_RENT_BASE, TYPE_TERM, PRICE_RENT_LONG, PRICE_SELL, CURRENCY} = this.state;

        let {createdObject,currencies} = this.props;
        if(currencies === undefined){
            currencies = [];
        }

        if (type === ObjectConst.TYPE.RENT) {
            return (
                <div className={
                    this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
                }>
                    <div className="heading">
                        <h3>
                            {i18n['creatingObjectPage.priceList']}
                        </h3>
                    </div>
                    {this.props.permissions.indexOf("rentamania.property.terms.long") != -1 && <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            {i18n['creatingObjectPage.priceList.hint1']}
                        </span>
                    </span>
                        {i18n['creatingObjectPage.typeOfLease']}:
                        <select
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            value={TYPE_TERM}
                            name={ObjectConst.FIELDS.TYPE_TERM}
                        >
                            {this.props.typeTerms.map(item => {
                                    if (item.title !== null) {
                                        return <option key={item.value} value={item.value}>{item.title}</option>
                                    } else {
                                        return null;
                                    }
                                }
                            )}
                        </select>
                    </label>}
                    {TYPE_TERM === ObjectConst.TYPE_TERM.LONG && <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            {i18n['creatingObjectPage.priceList.hint2']}
                        </span>
                    </span>
                        {i18n['creatingObjectPage.pricePerMonth']}, {createdObject.price.currency}:
                        <input
                            placeholder="0"
                            value={PRICE_RENT_LONG}
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            name={ObjectConst.FIELDS.PRICE_RENT_LONG}
                            className={classnames({
                                'invalid': PRICE_RENT_LONG.length === 0
                            })}
                        />
                    </label>}
                    <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>{i18n['creatingObjectPage.priceList.hint3']}</span>
                    </span>
                        {i18n['creatingObjectPage.basicRentalPrice']}, {createdObject.price.currency}:
                        <input
                            placeholder="0"
                            value={PRICE_RENT_BASE}
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            name={ObjectConst.FIELDS.PRICE_RENT_BASE}
                            className={classnames({
                                'invalid': PRICE_RENT_BASE.length === 0
                            })}
                        />
                    </label>

                    <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span></span>
                    </span>
                        {i18n['creatingObjectPage.currency']}:
                        <select
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            value={CURRENCY}
                            name={ObjectConst.FIELDS.CURRENCY}
                        >
                            {currencies.map(item => {
                                    return <option key={item} value={item}>{item}</option>
                                }
                            )}
                        </select>
                    </label>
                </div>
            )
        } else {
            return (
                <div className={
                    this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
                }>
                    <div className="heading">
                        <h3>
                            {i18n['creatingObjectPage.priceList']}
                        </h3>
                    </div>
                    <label>
                    <span className="info">
                        <i className="fa fa-question-circle"/>
                        <span>
                            {i18n['creatingObjectPage.priceList.hint4-1']} {createdObject.price.currency}. {i18n['creatingObjectPage.priceList.hint4-2']}
                        </span>
                    </span>
                        {i18n['creatingObjectPage.sellingPrice']}, {createdObject.price.currency}:
                        <input
                            placeholder="0"
                            value={PRICE_SELL}
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            name={ObjectConst.FIELDS.PRICE_SELL}
                            className={classnames({
                                'invalid': PRICE_SELL.length === 0
                            })}
                        />
                    </label>
                </div>
            )
        }
    }
}

Prices.propTypes = propTypes;
Prices.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    typeTerms: state.configuration.object.typeTerms,
    currencies: state.configuration.currencies,
    createdObject: state.creatingObjectPage.createdObject,
    type: state.creatingObjectPage.createdObject.props.type,
    isPricesValid: state.creatingObjectPage.validation.isPricesValid,
    permissions: state.user.currentUser.permissions,
});

const mapDispatchToProps = {
    updateField,
    setPricesValid
};

export default connect(mapStateToProps, mapDispatchToProps)(Prices);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/Prices.js